import React, { useState } from 'react';
import DropdownMenu from './DropdownMenu';
import FilterConversationItem from './FilterConversationItem';

const conversation_filters_row_1 = [
  { label: 'Confirmed', value: 'CONFIRMED' },
  { label: 'Rescheduled', value: 'RESCHEDULED' },
  { label: 'Canceled', value: 'CANCELLED' },
  { label: 'In progress', value: 'IN_PROGRESS' },
  { label: 'Opted out', value: 'OPTED_OUT' },
  { label: 'Unconfirmed', value: 'UNCONFIRMED' },
  { label: 'Reschedule requested', value: 'RESCHEDULE_REQUESTED' },
  { label: 'Cancel requested', value: 'CANCEL_REQUESTED' },
  { label: 'Reminders unavailable', value: 'TST' },
  { label: 'Confirmed off platform', value: 'CONFIRMED_OFF_PLATFORM' },
];
const FilterConversations = ({
  onChange,
  filter,
  clearFilter,
  applyFilter,
  selectedOption,
  ...rest
}) => {
  return (
    <DropdownMenu {...rest}>
      <div className="options-group">
        <div className="sources">
          <div className="multi-row-filter">
            <div className="filter-row" style={{ padding: '10px' }}>
              {conversation_filters_row_1.map((item, index) => {
                return (
                  <FilterConversationItem
                    label={item.label}
                    key={index}
                    value={item.value}
                    onClick={onChange}
                    type="BUTTON"
                    className={''}
                    iconclassName={'fas fa-flag'}
                    selectedOption={selectedOption}
                    filter={filter}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <div className="actions">
        <button
          className="btn btn--primary btn--lg apply"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            applyFilter();
          }}
        >
          APPLY
        </button>
        <div
          className="clear"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            clearFilter();
          }}
        >
          clear selection
        </div>
      </div>
    </DropdownMenu>
  );
};

export default FilterConversations;
